/* Sales Outreach · Stap 3 — Unified Inbox (ScaleIQ-style 3-column view).
 * The old approval-cards layout was retired on user request — drafts /
 * pending / sent / replied all flow through the same conversation view now,
 * with the three tabs at the top of the inbox: Conversations · Upcoming · Sent.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../Dashboard";
import UnifiedInbox from "@/components/inbox/UnifiedInbox";
import ReplyRatePanel from "@/components/inbox/ReplyRatePanel";
import AiCostPanel from "@/components/inbox/AiCostPanel";
import DraftBatchPanel from "@/components/inbox/DraftBatchPanel";
import BestSendTimePanel from "@/components/inbox/BestSendTimePanel";
import FollowupPanel from "@/components/inbox/FollowupPanel";
import ABTestPanel from "@/components/inbox/ABTestPanel";
import CollapsibleStats from "@/components/inbox/CollapsibleStats";

export default function SalesOutreach() {
    const { t } = useTranslation();
    return (
        <PageHeader
            title={t("outreach_sales.title")}
            subtitle={t("outreach_sales.subtitle")}>
            <CollapsibleStats>
                <DraftBatchPanel pillar="sales" />
                <FollowupPanel />
                <BestSendTimePanel />
                <ABTestPanel />
                <ReplyRatePanel />
                <AiCostPanel />
            </CollapsibleStats>
            <UnifiedInbox pillar="sales" />
        </PageHeader>
    );
}
